import { of } from "rxjs";
import { CentrifugeClient } from "./ws-client.js";
class CentrifugePrivateClient extends CentrifugeClient {
  constructor(apiUrl, refreshUrl, handler) {
    super();
    this.refreshHeaders = {};
    this.apiUrl = apiUrl;
    this.refreshUrl = refreshUrl;
    this.handler = handler;
    if (handler) {
      this.setPageHideListeners();
    }
  }
  static async create(apiUrl, refreshUrl, isProtoBuf = false) {
    const url = apiUrl + "?cf_protocol_version=v2";
    const client = new CentrifugePrivateClient(apiUrl + "?cf_protocol_version=v2", refreshUrl, null);
    const getTokenFn = client.refreshToken.bind(client);
    if (isProtoBuf) {
      const { Centrifuge: CentrifugeProtoImpl } = await import("centrifuge/build/protobuf");
      client.handler = new CentrifugeProtoImpl(url, { getToken: getTokenFn });
    } else {
      const { Centrifuge: CentrifugeImpl } = await import("centrifuge");
      client.handler = new CentrifugeImpl(url, { getToken: getTokenFn });
    }
    if (!client.listenersSet) {
      client.setPageHideListeners.call(client);
    }
    return client;
  }
  setToken(token, setRefreshHeaders) {
    super.destroy();
    this.refreshHeaders = setRefreshHeaders;
    this.handler.setToken(token);
    super.connect();
  }
  tokenUpdate(setRefreshHeaders) {
    this.refreshHeaders = setRefreshHeaders;
    return of(setRefreshHeaders);
  }
  async refreshToken() {
    const response = await fetch(this.refreshUrl, {
      credentials: "include",
      headers: this.refreshHeaders
    });
    if (!response.ok) {
      if (response.status === 403) {
        const { UnauthorizedError } = await import("centrifuge");
        throw new UnauthorizedError("Token refresh unauthorized");
      }
      throw new Error(`Token refresh failed: ${response.status}`);
    }
    const data = await response.json();
    return data == null ? void 0 : data.token;
  }
}
export {
  CentrifugePrivateClient
};
